import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-protocolo-nao-fiscal',
  templateUrl: './protocolo-nao-fiscal.component.html'
})
export class ProtocoloNaoFiscalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
